import { useRefreshOnFocus } from "@/hooks/useRefreshOnFocus";
import { fetchRates } from "@/services/rates.queries";
import { useToastNotify } from "@/stores/toastStore";
import { useQuery } from "@tanstack/react-query";
import { useT } from "@transifex/react";
import { useState } from "react";

export const useRates = () => {
  const { notify } = useToastNotify();
  const [errorNotified, setErrorNotified] = useState(false);
  const t = useT();

  const { data, isPending, isFetching, isLoading, isError, error, refetch } = useQuery({
    queryKey: ["rates"],
    queryFn: fetchRates,
    staleTime: 0,
    gcTime: 0,
  });

  if (isError && !errorNotified) {
    notify({
      severity: "error",
      message: t("An error occurred when fetching rates data"),
    });
    console.error("Error fetching rates data:", error);
    setErrorNotified(true);
  }
  if (!isError && errorNotified) {
    setErrorNotified(false);
  }

  useRefreshOnFocus(refetch);

  return {
    rates: data?.rates,
    // rates: [],
    noRatesMessage: data?.noRatesMessage,
    isPending,
    isFetching,
    isLoading,
  };
};
